const customFieldTypesOptions = [
  {
    'label': 'customField.type.boolean',
    'value': 'BOOLEAN'
  },
  {
    'label': 'customField.type.date',
    'value': 'DATE'
  },
  {
    'label': 'customField.type.dateTime',
    'value': 'DATE_TIME'
  },
  {
    'label': 'customField.type.select',
    'value': 'SELECT'
  },
  {
    'label': 'customField.type.text',
    'value': 'TEXT'
  }
]
export default customFieldTypesOptions
